import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ITranslatedTableService } from 'app/admin/config/TranslatedTableConfig';

@Injectable({
  providedIn: 'root'
})
export class BlacklistService implements ITranslatedTableService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/blacklist`;

  constructor(private http: HttpClient) { }

  getMany(languageId: number): Observable<Boo.Objects.Blacklist[]> {
    const params = new HttpParams().set('languageId', languageId);

    return this.http.get<Boo.Objects.Blacklist[]>(`${this.baseUrl}/GetMany`, { params: params });
  }

  saveMany(translations: Boo.Objects.Blacklist[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/SaveMany`, translations);
  }
}
